import { render, staticRenderFns } from "./BlockDeletedProperties.vue?vue&type=template&id=7c73c6a3&scoped=true&"
import script from "./BlockDeletedProperties.vue?vue&type=script&lang=js&"
export * from "./BlockDeletedProperties.vue?vue&type=script&lang=js&"
import style0 from "./BlockDeletedProperties.vue?vue&type=style&index=0&id=7c73c6a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c73c6a3",
  null
  
)

export default component.exports